export default __webpack_public_path__ + "static/media/Amazon.33cdc42e.png";